import React, { useState, useEffect } from 'react';
import { createShift, fetchPortsList } from './services/api';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Card, Alert, Container, Spinner } from 'react-bootstrap';
import { useAuth } from './AuthContext';

const CreateShift: React.FC = () => {
  const [name, setName] = useState('');
  const [port, setPort] = useState<number | ''>('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [duration, setDuration] = useState('');
  const [ports, setPorts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { token } = useAuth();

  useEffect(() => {
    fetchPortsList().then((response) => setPorts(response.data)).catch(() => setPorts([]));
    if (token && token.designation?.user_type === 'ADMIN' && token.port) {
      setPort(token.port);
    }
  }, [token]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await createShift({
        name,
        port: Number(port),
        start_time: startTime,
        end_time: endTime,
        duration_hours: Number(duration)
      });
      setSuccess(true);
      setTimeout(() => navigate('/shifts'), 1200);
    } catch (err) {
      setError('Failed to create shift');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="p-4 p-md-5" style={{ maxWidth: 500 }}>
      <Card className="shadow-lg mt-4">
        <Card.Body>
          <h2 className="mb-4">Create Shift</h2>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" value={name} onChange={e => setName(e.target.value)} required maxLength={50} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="port">
              <Form.Label>Location</Form.Label>
              <Form.Select value={port} onChange={e => setPort(e.target.value === '' ? '' : Number(e.target.value))} required disabled={!!(token && token.designation?.user_type === 'ADMIN' && token.port)}>
                <option value="">Select Location</option>
                {ports?.map((p: any) => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3" controlId="startTime">
              <Form.Label>Start Time</Form.Label>
              <Form.Control type="time" value={startTime} onChange={e => setStartTime(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-3" controlId="endTime">
              <Form.Label>End Time</Form.Label>
              <Form.Control type="time" value={endTime} onChange={e => setEndTime(e.target.value)} required />
            </Form.Group>
            <Form.Group className="mb-4" controlId="duration">
              <Form.Label>Duration (hours)</Form.Label>
              <Form.Control type="number" value={duration} onChange={e => setDuration(e.target.value)} required min={1} />
            </Form.Group>
            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">Shift created!</Alert>}
            <div className="d-flex justify-content-between">
              <Button type="button" variant="secondary" onClick={() => navigate('/shifts')} disabled={loading}>Back to List</Button>
              <Button type="submit" variant="primary" disabled={loading}>{loading ? <Spinner size="sm" animation="border" /> : 'Create Shift'}</Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CreateShift; 